import { applyMiddleware, createStore } from "redux"
import { persistCombineReducers, persistStore } from 'redux-persist'
import thunk from "redux-thunk"
import { getItem, removeItem, setItem } from '../lib/storage'
import { auth, authInitialize, AuthState } from './auth'
import { history, historyInitialize, HistoryState } from "./history"
import { notification, notificationInitialize, NotificationState } from './notification'
import { peter, peterInitialize, PeterState } from './peter'
import { quote, quoteInitialize, QuoteState } from "./quote"
import { scan, scanInitialize, ScanState } from "./scan"

export const store = createStore(
  persistCombineReducers(
    {
      key: 'fertigteilhaus',
      storage: {
        getItem,
        setItem,
        removeItem,
      },
      whitelist: [
        'quote',
        'history',
        'scan',
      ],
    },
    {
      auth,
      scan,
      quote,
      history,
      notification,
      peter,
    }
  ),
  applyMiddleware(thunk)
);

export type State = {
  auth: AuthState,
  quote: QuoteState,
  history: HistoryState,
  scan: ScanState,
  notification: NotificationState,
  peter: PeterState,
}

export type GetState = () => State

export const persistor = persistStore(store)

export const storeInitialize = () => async (dispatch: any) => {
  await authInitialize()(dispatch)
  await quoteInitialize()(dispatch)
  await historyInitialize()(dispatch)
  await scanInitialize()(dispatch)
  await notificationInitialize()(dispatch)
  await peterInitialize()(dispatch)
}
